import React from 'react';
import { Card } from "react-bootstrap";
import face_image_1 from "../../assets/img/faceIstvanMiklos.png";
import face_image_2 from "../../assets/img/faceJohnGait.jpeg";
import ShowMoreText from "react-show-more-text";
import proj_image from "../../assets/img/projMiklosI_GaitJ_pottery.png";

const I_Miklos_and_J_Gait_pottery = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}
        <Card.Img variant="top" src={proj_image} />
        <br />
        <Card.Body>
          <Card.Text class="d-flex justify-content-between card-text">
            {" "}

            <div>
            <img
              className="img2"
              src={face_image_1}
              
            />{" "}
            <p className="text7">István Miklós{" "}</p>
            <br />
            <p className="text8">
              Senior Research Fellow{" "}
            </p>
            </div>
            <div>
            <img
              className="img2"
              src={face_image_2}
              
            />{" "}
            <p className="text7">John Gait{" "}</p>
            <br />
            <p className="text8">
              Archaeologist {" "}
            </p>
            </div>
            
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            <p className="text8">Rényi Institute, HUN-REN </p>
            </div>
            <div>
            <p className="text8">Heritage Science Group, HUN-REN </p>
            </div>
            <div>
            Recent advances in non-destructive 3D X-ray microtomography imaging (μ-CT) of cultural heritage artefacts offer the 
            opportunity to investigate ancient technology in unprecedented detail, including supplementing empirical visual 
            assessments with novel robust quantitative measures. This quantitative approach is currently being developed to 
            investigate the techniques used to shape and form ancient pottery, using the 3D orientation of particles and voids 
            within ceramic fabrics. Experimental studies have shown that these elements become preferentially orientated in 
            particular patterns according to the manner in which forces are applied during different hand-building, wheel-based, 
            or composite forming techniques. 
            <br/>
            <br/>
            However, following image segmentation, analysing the large datasets generated poses a number of challenges, in 
            particular regarding the analysis of circular and spherical directional data, where conventional statistical models 
            fall short due to the cyclical nature of the data. 
            <br/>
            <br/>
            This project may be divided into two related tasks, but which may be undertaken together or individually.
            <ol>
                <li>
                    This task will explore the use of circular data analysis techniques, including circular principal component 
                    analysis (PCA) techniques such as the von Mises distribution and Wasserstein PCA, with regard to both 
                    aggregated spherical directional data and a range of other parameters obtained from μ-CT datasets (aspect 
                    ratio, frequency, sphericity, volume, voxel count, etc.)  
                </li>
                <li>
                    In addition to the spherical directional data of individual elements, the 3D spatial arrangement of these 
                    elements relative to one another within a defined spatial environment may also be significant in 
                    differentiating specific forming techniques. For example, when described by directional values alone, a 
                    randomly orientated population may be indistinguishable from a population spatially arranged in a circular 
                    or spiral pattern. This task will investigate how to detect such spatially defined patterns, and the 
                    effectiveness of previously proposed approaches, such as the Hough Transform.  
                </li>
            </ol>
            <br/>
            Computational analysis will be undertaken using Python, R, or other suitable statistical software. The tasks will be 
            applied to simulations of the expected 3D orientation of objects according to various pottery forming techniques, and 
            also to the analysis of μ-CT data from a range of ancient pottery, including Neolithic to Roman Age vessels from 
            Austria, Egypt, Hungary, Italy and Sudan. The project will involve close corporation between the Alfréd Rényi 
            Institute of Mathematics and archaeological scientists and instrument scientists at the HUN-REN Centre for Energy 
            Research.

            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default I_Miklos_and_J_Gait_pottery;